module.exports = "@media screen and (min-width: 991px) {\n  .card-title {\n    font-size: 17px; } }\n"